var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-field-input',{attrs:{"label":"Label","validation-errors":_vm.validationErrors.label},model:{value:(_vm.form.label),callback:function ($$v) {_vm.$set(_vm.form, "label", $$v)},expression:"form.label"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }